var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2009_2040)","key":0},React.createElement("path",{"d":"M24 12C24 5.37259 18.6274 -1.90735e-06 12 -1.90735e-06C5.37259 -1.90735e-06 0 5.37259 0 12C0 17.6278 3.87432 22.3499 9.10109 23.6466V15.667H6.62659V12H9.10109V10.4199C9.10109 6.33547 10.9495 4.44235 14.9594 4.44235C15.7196 4.44235 17.0314 4.59139 17.568 4.74048V8.06467C17.2848 8.03486 16.7929 8.01993 16.1817 8.01993C14.214 8.01993 13.4538 8.76528 13.4538 10.7031V12H17.3734L16.7001 15.667H13.4538V23.9121C19.3955 23.1945 24 18.1353 24 12Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2009_2040"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":"Facebook svg image"};

module.exports = Facebook;

Facebook.default = Facebook;
